import * as React from "react";
import { forwardRef, memo } from "react";
const SvgVectorIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 7.5, viewBox: "0 0 18 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.1836 1L8.68359 8.5L1.18359 1", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgVectorIcon);
const Memo = memo(ForwardRef);
export default Memo;
